<template>
	<CFormGroup
		v-bind="{
			append,
			prepend,
			validFeedback,
			invalidFeedback,
			tooltipFeedback,
			description,
			wrapperClasses,
			class: computedClasses,
		}">
		<template #label>
			<slot name="label">
				<label v-if="label" :for="safeId" :class="labelClasses">
					{{ label }}
				</label>
			</slot>
		</template>
		<template #input>
			<div class="input-wrapper">
				<input
					v-bind="$attrs"
					v-on="listeners"
					:id="safeId"
					:type="isPassword ? (passwordShown ? 'text' : 'password') : type"
					:class="inputClasses"
					:readonly="readonly || plaintext"
					:value="state"
					@input="onInput($event)"
					@change="onChange($event)" />
				<button v-if="isPassword" @click="$event => togglePassword($event)" class="password-btn">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						:viewBox="!passwordShown ? '0 0 576 512' : '0 0 640 512'">
						<path
							v-if="!passwordShown"
							d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
						<path
							v-if="passwordShown"
							d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z" />
					</svg>
				</button>
			</div>
		</template>

		<template v-for="slot in $options.slots" #[slot]>
			<slot :name="slot"></slot>
		</template>
	</CFormGroup>
</template>

<script>
	import CFormGroup from '../GComponentsLibraries/VueFiles/GFormGroup';
	import { inputProps as props } from '../GComponentsLibraries/JsFiles/form-props';
	import * as allFormMixins from '../GComponentsLibraries/JsFiles/form-mixins';
	const mixins = Object.values(allFormMixins);

	export default {
		name: 'GInput',
		slots: [
			'prepend',
			'prepend-content',
			'append-content',
			'append',
			'label-after-input',
			'valid-feedback',
			'invalid-feedback',
			'description',
		],
		inheritAttrs: false,
		components: { CFormGroup },
		mixins,
		props,
		// Html props: disabled, required, rows, cols, placeholder
		// {
		//   validFeedback: String,
		//   invalidFeedback: String,
		//   tooltipFeedback: Boolean,
		//   description: String,

		//   append: String,
		//   prepend: String,

		//   label: String,
		//   wasValidated: Boolean,
		//   isValid: {
		//     type: [Boolean, Function],
		//     default: null
		//   },
		//   addInputClasses: [String, Array, Object],
		//   addLabelClasses: [String, Array, Object],

		//   horizontal: [Boolean, Object],
		//   size: {
		//     type: String,
		//     validator: str => ['','sm','lg'].includes(str)
		//   },
		//   addWrapperClasses: [String, Array, Object],

		//   readonly: Boolean,
		//   plaintext: Boolean,
		//   value: [String, Number],
		//   lazy: {
		//     type: [Boolean, Number],
		//     default: 400
		//   },
		//   type: {
		//     type: String,
		//     default: 'text'
		//   }
		// },
		data() {
			return {
				state: this.value,
				syncTimeout: null,
				isPassword: this.type == 'password',
				passwordShown: false,
			};
		},
		//watchValue mixin
		// watch: {
		//   value (val) {
		//     this.state = val
		//   }
		// },
		computed: {
			listeners() {
				const { input, change, ...listeners } = this.$listeners; // eslint-disable-line no-unused-vars
				return listeners;
			},
			// classesComputedProps mixin
			// haveCustomSize () {
			//   return ['sm','lg'].includes(this.size)
			// },
			computedClasses() {
				return [
					'form-group',
					{
						'was-validated': this.wasValidated,
						'form-row': this.isHorizontal,
						required: this.$attrs.required === '',
					},
				];
			},
			// labelClasses () {
			//   return [
			//     this.addLabelClasses,
			//     {
			//       'col-form-label': this.isHorizontal,
			//       [this.horizontal.label || 'col-sm-3']: this.isHorizontal,
			//       [`col-form-label-${this.size}`]: this.haveCustomSize,
			//     }
			//   ]
			// },
			// customSizeClass () {
			//   if (this.haveCustomSize && !this.haveWrapper) {
			//     return `form-control-${this.size}`
			//   }
			// },
			// inputClasses () {
			//   return [
			//     this.inputClass || `form-control${this.plaintext ? '-plaintext' : ''}`,
			//     this.validationClass,
			//     this.addInputClasses,
			//     this.customSizeClass
			//   ]
			// }

			// validationComputedProps mixin
			// computedIsValid () {
			//   if (typeof this.isValid === 'function') {
			//     return this.isValid(this.state)
			//   }
			//   return this.isValid
			// },
			// validationClass () {
			//   if (typeof this.computedIsValid === 'boolean') {
			//     return this.computedIsValid ? 'is-valid' : 'is-invalid'
			//   }
			// }

			//wrapperComputedProps mixin
			// isHorizontal () {
			//   return Boolean(this.horizontal)
			// },
			// haveInputGroup () {
			//   return Boolean(
			//     this.tooltipFeedback ||
			//     this.append ||
			//     this.prepend ||
			//     this.$slots.append ||
			//     this.$slots.prepend ||
			//     this.$slots['append-content'] ||
			//     this.$slots['prepend-content']
			//   )
			// },
			// haveWrapper () {
			//   return this.haveInputGroup || Boolean(this.addWrapperClasses || this.isHorizontal)
			// },
			// wrapperClasses () {
			//   if (this.haveWrapper) {
			//     return [
			//       this.addWrapperClasses,
			//       {
			//         [this.horizontal.input || 'col-sm-9'] : this.isHorizontal,
			//         'input-group' : this.haveInputGroup,
			//         [`input-group-${this.size}`]: this.haveCustomSize
			//       }
			//     ]
			//   }
			// }
		},
		methods: {
			onInput(e) {
				this.state = e.target.value;
				this.$emit('input', this.state, e);
				if (this.lazy === true) {
					return;
				}

				clearTimeout(this.syncTimeout);
				this.syncTimeout = setTimeout(
					() => {
						this.$emit('update:value', this.state, e);
					},
					this.lazy !== false ? this.lazy : 0
				);
			},
			onChange(e) {
				this.state = e.target.value;
				this.$emit('change', this.state, e);
				this.$emit('update:value', this.state, e);
			},
			togglePassword(e) {
				if (e) e.preventDefault();
				this.passwordShown = !this.passwordShown;
			},
		},
	};
</script>

<style scoped>
	.form-group.required label:after {
		content: '*';
		color: red;
	}
	.input-wrapper {
		position: relative;
	}
	button.password-btn {
		position: absolute;
		width: 25px;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
		border: none;
		background: none;
		padding: 0;
		margin: 0;
		outline: none;
	}

	button.password-btn svg {
		opacity: 0.5;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
</style>
